import { Validator } from './Validator';

export type FormErrors = {
	oldPassword: string;
	newPassword: string;
	newPasswordConfirm: string;
};

export const initialFormErrors: FormErrors = {
	oldPassword: '',
	newPassword: '',
	newPasswordConfirm: '',
};

export const getErrorMessage = <T>(name: string, value: T): string => {
	const validator = new Validator(value);
	switch (name) {
		case 'oldPassword':
			return validator.require().end();
		case 'newPassword':
		case 'newPasswordConfirm':
			return validator.require().charTypePassword().end();
		default:
			return '';
	}
};
